import { useEffect } from 'react'
import Head from 'next/head'
import dynamic from 'next/dynamic'
import Header from '../components/header'
const Footer = dynamic(() => import('../components/footer'))

import AlphaList from '../components/taxonomies/alphafilter/alphalist-spareparts'
const MiniCart = dynamic(() => import('../components/cart/minicart'))

import Breadcrumbs from "../components/Breadcrumbs";
import parse from 'html-react-parser'

function Category({ list, menu, config, page }) {

  // const dispatch = useDispatch();

  // useEffect(() => {
  //   dispatch(addStep({st : 0, item : ''}))
  //   dispatch(clearbreadcrumb())
  //   }, [list]);

  return (
    <>
      <Head>
        <title>{page.meta_title ? page.meta_title : ''}</title>
        <meta name="keywords" content={page.meta_keywords ? page.meta_keywords : ''}></meta>
        <meta name="description" content={page.meta_description ? page.meta_description : ''}></meta>
      </Head>
      <div className="wrapper h-full flex flex-col">
        <Header menu={menu} config={config}></Header>
        <Breadcrumbs links={[[["Select Brand", "/spareparts", "Brand", 0]]]} />
        <AlphaList list={list} type="sparepart" title="Brand" step={1}></AlphaList>
        {(page && page.description) ? (parse(page.description)) : ('')}
        <Footer menu={menu} config={config}></Footer>
      </div>
      <MiniCart></MiniCart>
    </>
  )
}


// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// revalidation is enabled and a new request comes in
export async function getStaticProps(context) {
  const config_res = await fetch(process.env.NEXT_PUBLIC_API_URL + '/configs')
  const config_data = await config_res.json()
  const config = config_data.data

  const menu_res = await fetch(process.env.NEXT_PUBLIC_API_URL + '/menu')
  const menu = await menu_res.json()

  const taxres = await fetch(process.env.NEXT_PUBLIC_API_URL + '/taxonomies/sparepart')
  const taxresponse = await taxres.json()
  const list = taxresponse.data

  const res = await fetch(process.env.NEXT_PUBLIC_API_URL + '/landingpage/sparepart')
  const response = await res.json()
  const page = response.data

  return {
    props: {
      config: config,
      menu: menu,
      list: list,
      page: page,
    },
    // Next.js will attempt to re-generate the page:
    // - When a request comes in
    // - At most once every 10 seconds
    revalidate: 600, // In seconds

  }
}



export default Category